import { useMemo } from 'react'
import { getRecommendationPlaceIds, getSearchedPlaces } from 'lib/search/searchedPlaces'

const MIN_DISTINCT_PLACE_IDS_TO_ACTIVATE = 3

function useRecommendationPlaceIds(): Array<string> {
  const distinctPlaceIds = new Set(
    getSearchedPlaces({ excludeAnywhere: true }).map(place => place.placeId),
  )
  const hasEnoughPlaces = distinctPlaceIds.size >= MIN_DISTINCT_PLACE_IDS_TO_ACTIVATE

  return useMemo(
    () => hasEnoughPlaces ? getRecommendationPlaceIds() : [],
    [hasEnoughPlaces],
  )
}

export default useRecommendationPlaceIds
